export default "__VITE_PUBLIC_ASSET__7516017d__"